var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.93 0.5C1.23 0.5 0 1.67 0 3.29C0 4.9 1.21 6.07 2.88 6.07C3.74 6.07 4.49 5.79 5.03 5.26C5.55 4.75 5.84 4.05 5.84 3.27C5.8 1.64 4.6 0.5 2.93 0.5ZM4.27 4.48C3.93 4.81 3.45 4.98 2.88 4.98C1.83 4.98 1.1 4.28 1.1 3.28C1.1 2.26 1.83999 1.58 2.93999 1.58C4.01999 1.58 4.73 2.25 4.75 3.28C4.75 3.76 4.58 4.18 4.27 4.48Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.519531 24.9602H5.40953V6.99023H0.519531V24.9602ZM1.60954 8.08023H4.31953V23.8702H1.60954V8.08023Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2992 6.99023C16.0392 6.99023 14.6492 7.77023 13.8392 8.51023L13.6892 6.99023H8.15918V24.9602H13.5792V15.5202C13.5792 15.1102 13.7392 14.2702 13.8492 14.0402C14.4992 12.6302 15.3892 12.6302 16.7192 12.6302C18.2592 12.6302 19.5592 14.0702 19.5592 15.7802V24.9502H24.9992V14.8002C24.9892 9.43023 21.5192 6.99023 18.2992 6.99023ZM23.9092 23.8702H20.6492V15.7802C20.6492 13.4802 18.8492 11.5402 16.7192 11.5402C15.3492 11.5402 13.8092 11.5402 12.8592 13.5802C12.6592 14.0002 12.4892 15.0102 12.4892 15.5102V23.8602H9.24918V8.08023H12.7092L12.9292 10.2802H13.8192L13.9792 10.0202C14.3392 9.44023 15.4892 8.08023 18.2992 8.08023C20.9992 8.08023 23.9092 10.1902 23.9092 14.8102V23.8702Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.a835c2795c21d1be6c8ae269816c89f8.svg";
export { ForwardRef as ReactComponent };